/**
 * ReferenceAccordion
 */
import clsx from 'clsx';
import React, { useState } from 'react';
import { Icon } from 'ui-component-library/base';
import { useUuid /*useCtrlF*/ } from 'ui-component-library/hooks';
import { Transition } from 'react-transition-group';
/** Accordion with references */
var ReferenceAccordion = function (_a) {
    var heading = _a.heading, children = _a.children, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h3' : _b;
    var _c = useState(false), expanded = _c[0], setExpanded = _c[1];
    var getUuid = useUuid()[0];
    var id = getUuid();
    var Heading = headingLevel;
    return (React.createElement("div", { className: "border-t-2 border-b-2 border-borderColor" },
        React.createElement("button", { onClick: function () {
                setExpanded(!expanded);
            }, className: "w-full cursor-pointer flex items-center justify-between py-4", "aria-expanded": expanded, "aria-controls": "reference-accordion-item-content-" + id, id: "reference-accordion-item-button-" + id },
            React.createElement("div", { className: "flex items-center" },
                React.createElement("div", { className: "pr-3" },
                    React.createElement(Icon, { size: 1.25, icon: 'paragraph' })),
                React.createElement(Heading, { className: "mt-1 font-semibold text-h4" }, heading)),
            React.createElement("div", null,
                React.createElement(Icon, { "aria-hidden": true, icon: "chevron", size: 1, className: "text-purple", direction: expanded ? 'down' : 'up' }))),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: "reference-accordion-item-content-" + id, role: "region", "aria-labelledby": "reference-accordion-item-button-" + id, hidden: state === 'exited', className: clsx(state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in', 'richtext referenceaccordion px-3') }, children)); })));
};
export default ReferenceAccordion;
